import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';


@Pipe({
  name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

 transform(url: string, type?:string|'image/jpeg'): SafeUrl {
  //data:${data.ImageMimeType.MimeTypeName}:base64
    let imageUrl = `data:${type};base64,${url}`;
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }

}
